import { Suspense, useContext, useEffect } from "react"
import { useLocation } from "react-router-dom"
import { allAnimations } from "../effects/Observers"
import LoadingComponent from "../components/LoadingComponent"
import { useTranslation } from "react-i18next";
import ScreenContainer from "../components/ScreenContainer";
import { ThemeContext } from "../contexts/theme/ThemeContext";
import PrivacySection from "../components/PrivacySection";

export const PrivatePolicyScreen = () => {

    const location = useLocation()

    const { t } = useTranslation();

    const privacyTitle: any = t('policy.title', { returnObjects: true });
    const privacyData: any = t('policy.data', { returnObjects: true });

    const {
        theme,
    } = useContext(ThemeContext);


    const { i18n } = useTranslation();

    useEffect(() => {

        allAnimations();

        return () => { allAnimations() };

    }, [location.pathname, i18n.language, theme])

    return (

        <ScreenContainer>

            <div className="mt-5 lg:mt-10 xl:mt-20">

                <Suspense fallback={<LoadingComponent />}>


                    <PrivacySection
                        title={privacyTitle}
                        subtitles={privacyData}
                    />


                </Suspense>

            </div>

        </ScreenContainer>

    )
}
